<template>
    <v-dialog-old ref="dialog" id="doctorPaymentDataDialog">
        <RejectDialog ref="rejectDialog" @rejected="updated"/>

        <fieldset disabled>
            <legend>Анкета</legend>
            <div>
                <input type="text" :value="M.doctorUser.fullname" readonly class="large">
                <label>URL</label>
                <a :href="M.doctorUser.fullUrl" target="_blank">{{ M.doctorUser.fullUrl }}</a>
            </div>
        </fieldset>

        <fieldset disabled>
            <legend>ИНН</legend>
            <div>
                <label>ИНН</label>
                <input type="text" :value="M.INN" readonly style="width: 33%; display: block;">
                <a :href="M.INN_photo ? ('/storage.secure/doctors_docs/' + M.doctorUser.id + '/payment_data/' + M.INN_photo) : '#'"
                   target="_blank">
                    <img :src="M.INN_photo ? ('/storage.secure/doctors_docs/' + M.doctorUser.id + '/payment_data/' + M.INN_photo.replace('.pdf', '.jpg')) : ''"
                         alt="ИНН"
                         height="120"
                         style="margin-top: 5px;"/>
                </a>
            </div>
        </fieldset>

        <fieldset v-if="M.tax_type === 'SELF_EMPLOYED'" disabled>
            <legend>Самозанятый</legend>
            <div>
                <table class="grid">
                    <tr>
                        <td>
                            <label>Проверка по ИНН в ФНС</label>
                            <input type="text" :value="M.inn_verification_message" readonly :style="{ color: M.inn_verified ? 'darkgreen' : 'darkred' }">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Справка о постановке на учет (КНД 1122035)</label>
                            <a :href="M.self_employed_photo ? ('/storage.secure/doctors_docs/' + M.doctorUser.id + '/payment_data/' + M.self_employed_photo) : '#'"
                               target="_blank">
                                <img :src="M.self_employed_photo ? ('/storage.secure/doctors_docs/'  + M.doctorUser.id + '/payment_data/' + M.self_employed_photo.replace('.pdf', '.jpg')) : ''"
                                     alt="Справка о постановке на учет"
                                     height="120"
                                     style="margin-top: 5px;"/>
                            </a>
                        </td>
                    </tr>
                </table>
            </div>
        </fieldset>

        <fieldset v-if="M.tax_type === 'I_P'" disabled>
            <legend>Индивидуальный предприниматель</legend>
            <div>
                <label>ОГРНИП</label>
                <input type="text" :value="M.OGRNIP" readonly>
            </div>
        </fieldset>

        <fieldset disabled>
            <legend>Банковские реквизиты</legend>
            <table class="grid">
                <tr>
                    <td width="67%">
                        <label>Наименование банка</label>
                        <input type="text" :value="M.bank_name" readonly>
                    </td>
                    <td width="33%">
                        <label>БИК</label>
                        <input type="text" :value="M.BIK" readonly>
                    </td>
                </tr>
                <tr>
                    <td width="50%">
                        <label>Корреспондентский счет</label>
                        <input type="text" :value="M.correspondent_account" readonly>
                    </td>
                    <td width="50%">
                        <label>Счет получателя</label>
                        <input type="text" :value="M.recipient_account" readonly>
                    </td>
                </tr>
            </table>
        </fieldset>

        <footer>
            <v-loading-component v-if="M.status !== 'APPROVED'" @click="approve">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">Подтвердить</button>
                </template>
            </v-loading-component>
            <button v-if="M.status !== 'REJECTED'" class="red" @click="reject">Отказать</button>
        </footer>
    </v-dialog-old>
</template>

<script>
import RejectDialog from "@dialogs/admin/doctorPaymentData/RejectDialog";

export default {
    components: {RejectDialog},
    data: function () {
        return {
            M: {
                doctorUser: {
                    id: '',
                    fullname: '',
                    fullUrl: '',
                },
                id: null,
                INN: '',
                INN_photo: null,
                tax_type: null,
                self_employed_photo: null,
                OGRNIP: '',
                bank_name: '',
                BIK: '',
                correspondent_account: '',
                recipient_account: '',
                inn_verified: null,
                inn_verification_message: '',
            },
        };
    },
    methods: {
        resetData() {
            this.M = {
                doctorUser: {
                    id: null,
                    fullname: '',
                    fullUrl: '',
                },
                id: null,
                INN: '',
                INN_photo: null,
                tax_type: null,
                self_employed_photo: null,
                OGRNIP: '',
                bank_name: '',
                BIK: '',
                correspondent_account: '',
                recipient_account: '',
                inn_verified: null,
                inn_verification_message: '',
            };
        },
        show(id) {
            this.resetData();

            return this.axios.post('doctorPaymentData/read/' + id).then(response => {
                Object.assign(this.M, response.data);

                this.$refs.dialog.show();
            });
        },

        approve(btn) {
            if (!this.M.id) {
                return;
            }
            btn.startLoadingAnimation();

            this.axios.post('doctorPaymentData/approve/' + this.M.id).then(response => {
                btn.stopLoadingAnimation();

                this.updated();
            }).catch(() => btn.stopLoadingAnimation());
        },

        reject() {
            this.$refs.rejectDialog.show(this.M.id);
        },

        updated() {
            this.$refs.dialog.hide();
            this.$emit('updated');
        },
    },
}
</script>

<style>
#doctorPaymentDataDialog {
    width: 950px;
}
</style>
